// Get user from localStorage
export const getUser = () => {
  const savedUser = localStorage.getItem('user');
  return savedUser ? JSON.parse(savedUser) : null;
};

// Get specific user properties
export const getUserId = () => getUser()?.user_id;
export const getBranchId = () => getUser()?.branch_id;
export const getAdminId = () => getUser()?.admin_id;
export const getUserRole = () => getUser()?.role;
export const getUserName = () => getUser()?.name;
export const getUserEmail = () => getUser()?.email;

// Check if user is admin
export const isAdmin = () => {
  const role = getUserRole();
  return role === 'Admin' || role === 'admin';
};

// Check if user is dentist
export const isDentist = () => {
  const role = getUserRole();
  return role === 'Dentist' || role === 'dentist';
};

// Check if user is logged in
export const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  const user = getUser();
  return !!(token && user);
};

// Get auth token
export const getToken = () => localStorage.getItem('token');

// Set user session
export const setUserSession = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

// Clear user session
export const clearUserSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Permission checks
export const hasPermission = (action) => {
  const permissions = {
    'Admin': [
      'manage_branches',
      'manage_staff',
      'manage_treatments',
      'view_reports',
      'manage_settings',
      'view_all_branches',
      'manage_patients',
      'manage_appointments',
      'manage_invoices'
    ],
    'admin': [
      'manage_branches',
      'manage_staff',
      'manage_treatments',
      'view_reports',
      'manage_settings',
      'view_all_branches',
      'manage_patients',
      'manage_appointments',
      'manage_invoices'
    ],
    'dentist': [
      'manage_patients',
      'manage_appointments',
      'view_odontogram',
      'create_treatment_records',
      'issue_certificates'
    ],
    'Dentist': [
      'manage_patients',
      'manage_appointments',
      'view_odontogram',
      'create_treatment_records',
      'issue_certificates'
    ],
    'officer': [
      'manage_patients',
      'manage_appointments',
      'manage_invoices',
      'check_in_patients'
    ],
    'Officer': [
      'manage_patients',
      'manage_appointments',
      'manage_invoices',
      'check_in_patients'
    ]
  };

  const role = getUserRole();
  return permissions[role]?.includes(action) || false;
};

// Format date for display
export const formatDate = (date, locale = 'th-TH') => {
  if (!date) return '';
  return new Date(date).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Format datetime for display
export const formatDateTime = (date, locale = 'th-TH') => {
  if (!date) return '';
  return new Date(date).toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format time for display
export const formatTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleTimeString('th-TH', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Format currency
export const formatCurrency = (amount, currency = 'THB') => {
  if (amount === null || amount === undefined) return '฿0.00';
  return new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency
  }).format(amount);
};

// Calculate age from date of birth
export const calculateAge = (dob) => {
  if (!dob) return null;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

// Get image URL
export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}`;
};
